import { Routes } from '@angular/router';

import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    title: 'Sign in · Vestorise',
    loadComponent: () => import('./features/login/login').then((m) => m.Login),
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        title: 'Dashboard · Vestorise',
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'accounts',
        title: 'Accounts · Vestorise',
        loadComponent: () => import('./features/accounts/accounts').then((m) => m.Accounts),
      },
      {
        path: 'holdings',
        title: 'Holdings · Vestorise',
        loadComponent: () => import('./features/holdings/holdings').then((m) => m.Holdings),
      },
      {
        path: 'transactions',
        title: 'Transactions · Vestorise',
        loadComponent: () =>
          import('./features/transactions/transactions').then((m) => m.Transactions),
      },
      {
        path: 'watchlist',
        title: 'Watchlist · Vestorise',
        loadComponent: () => import('./features/watchlist/watchlist').then((m) => m.Watchlist),
      },
      {
        path: 'tax',
        title: 'Tax & Realized Gains · Vestorise',
        loadComponent: () => import('./features/tax/tax').then((m) => m.Tax),
      },
      // Temporarily hidden while Revolut sync is operationalized
      // {
      //   path: 'connections',
      //   title: 'Connections · Vestorise',
      //   loadComponent: () =>
      //     import('./features/connections/connections').then((m) => m.Connections),
      // },
      {
        path: 'settings',
        title: 'Settings · Vestorise',
        loadComponent: () => import('./features/settings/settings').then((m) => m.Settings),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
